import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Natural sort comparator for sehpa codes like "A-1", "A-10", "AX-2".
// Ensures 1,2,…,9,10,11 order instead of lexicographic 1,10,11,…,2,20.
export function naturalCompare(a, b) {
  return String(a ?? "").localeCompare(String(b ?? ""), undefined, {
    numeric: true,
    sensitivity: "base",
  });
}
